import { Colors, Spacing } from "_styles";


export const mainContainer = {
    // padding: Spacing.SCALE_12,
    zIndex: "initial",
}

export const subContainer = {
    // marginLeft: Spacing.SCALE_12,
    // marginBottom: Spacing.SCALE_22,
    width: "100%"
}

export const taskListContainer = {
    //display: "flex",
    overflowX: "scroll",
    //borderStyle: "solid", borderWidth:1
}

export const selectTaskErrorContainer = {
    backgroundColor: Colors.LIGHT_RED,
    borderRadius: 10,
    borderLeftWidth: 3,
    borderLeftStyle: "solid",
    borderLeftColor: Colors.DARK_RED,
    marginBottom: Spacing.SCALE_18,
}

export const selectTaskErrorDiv = {
    padding: Spacing.SCALE_18,
    display: "flex",
    alignItems: "center",
}

export const selectTaskErrorText = {
    color: Colors.DARK_RED,
    display: "flex",
    alignItems: "center",
    margin: 0,
    marginLeft: Spacing.SCALE_12,
}

export const warningMessageContainer = {
    borderRadius: 10,
    borderLeftWidth: 3,
    borderLeftStyle: "solid",
}

export const warningMessageDiv = {
    padding: Spacing.SCALE_18,
    display: "flex",
    alignItems: "center",
}

export const warningMessageText = {
    display: "flex",
    alignItems: "center",
    margin: 0,
    marginLeft: Spacing.SCALE_12,
}

export const informationContainer = {
    //marginLeft: Spacing.SCALE_8,
    //marginTop: Spacing.SCALE_22,
}